import React from 'react';
import { useTheme, useMergeClasses, EngineTheme } from '../../../../../theme';
import cn from 'classnames';

interface Props {
	classes?: EngineTheme['Shared']['QntBadge'];
	count: number;
	variant?: 'default' | 'invert';
	onClick?: () => void;
}

const QntBadge: React.FC<Props> = ({ classes, count, variant = 'default', onClick }) => {
	const { QntBadge: defaultClasses } = useTheme('Shared');

	const css = useMergeClasses(defaultClasses, classes);

	return (
		<span
			className={cn(css.badge, {
				[css.invert]: variant === 'invert',
				[css.clickable]: onClick
			})}
			onClick={onClick}
		>
			<span className={css.badge__count}>{count}</span>
		</span>
	);
};

export default QntBadge;
